<template>
  <transition name="fade">
    <div v-if="loading === true">
      <lottie class="imageLoader__Image" :options="defaultOptions" :height="400" :width="400" />
    </div>
  </transition>
</template>

<script>
import Lottie from '@/components/partials/Lottie'
import animationData from '@/assets/animations/progress_bar.json'

export default {
  name: 'Loader',
  components: {
    Lottie,
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData,
      },
    }
  },
  props: ['loading'],
}
</script>
